import { getUrlParams } from '@/helpers/getUrlParams';
import { isTier1Geo } from '@/helpers/isTier1Geo';
import { MONETIZATION_TEST } from '@/constants';

type MonetizationTestValue =
	(typeof MONETIZATION_TEST)[keyof typeof MONETIZATION_TEST];

/**
 * Picks a landing's funnel based on the `m_test` URL param — the same
 * branch every monetization-tested landing needs. Falls back to `fallbackFunnel`
 * when the param is missing, doesn't match any configured variant, or the user's
 * geo is Tier-1 — monetization tests only ever target non-Tier-1 geos.
 */
export function resolveFunnelUrlByMonetizationTest(
	variants: Partial<Record<MonetizationTestValue, () => string>>,
	fallbackFunnel: () => string,
): string {
	if (isTier1Geo()) return fallbackFunnel();

	const { m_test } = getUrlParams();
	const variantFunnel = m_test && variants[m_test as MonetizationTestValue];

	return variantFunnel ? variantFunnel() : fallbackFunnel();
}
